import React, { useState, useRef, useEffect } from 'react';
import { useApp } from '../context/AppContext';

function CurriculumChat() {
  const { t } = useApp();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const chatEndRef = useRef(null);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = {
      role: 'user',
      content: input
    };

    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setIsLoading(true);

    // Simula um pequeno delay para dar feedback visual
    setTimeout(() => {
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: t('chat.staticResponse')
      }]);
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="glass-effect rounded-lg p-4 max-w-2xl mx-auto">
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-text-light dark:text-text-dark mb-2">
          {t('chat.title')}
        </h2>
        <p className="card-text text-sm">
          {t('chat.description')}
        </p>
      </div>

      <div className="mb-4 p-3 bg-yellow-100 dark:bg-yellow-900 text-yellow-700 dark:text-yellow-100 rounded-lg">
        {t('chat.underConstruction')}
      </div>

      <div className="h-[400px] overflow-y-auto mb-4 p-4 glass-effect rounded-lg">
        {messages.map((message, index) => (
          <div
            key={index}
            className={`mb-4 ${
              message.role === 'user' ? 'text-right' : 'text-left'
            }`}
          >
            <div
              className={`inline-block p-3 rounded-lg ${
                message.role === 'user'
                  ? 'bg-primary-light dark:bg-primary-dark text-white'
                  : 'bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark'
              }`}
            >
              {message.content}
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="text-left">
            <div className="inline-block p-3 rounded-lg bg-background-light dark:bg-background-dark">
              <div className="flex space-x-2">
                <div className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full animate-bounce delay-100"></div>
                <div className="w-2 h-2 bg-primary-light dark:bg-primary-dark rounded-full animate-bounce delay-200"></div>
              </div>
            </div>
          </div>
        )}
        <div ref={chatEndRef} />
      </div>

      <form onSubmit={handleSubmit} className="flex gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={t('chat.placeholder')}
          className="flex-1 p-2 rounded-lg bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark border border-primary-light dark:border-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark"
        />
        <button
          type="submit"
          disabled={isLoading}
          className="px-4 py-2 bg-primary-light dark:bg-primary-dark text-white rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50"
        >
          {t('chat.send')}
        </button>
      </form>
    </div>
  );
}

export default CurriculumChat; 